<div class="connected-accounts-list">
  <button mat-raised-button color="white" *ngFor="let accountType of connectedAccountTypes" (click)="accountClicked(accountType)">
      <img [src]="imageFor(accountType)" />
      {{nameFor(accountType)}}
  </button>
  <div *ngIf="connectedAccountTypes.length == 0" class="connected-accounts-sorry">
    Keine weiteren Accounts verbindbar. Falls Sie einen Account erneut verbinden möchten, bitte löschen Sie diese Verbindung zuerst.
  </div>
</div>
